export default {
  AUDIENCE: 'Audience',
}
